exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-4728b5a4] {\n  background-color: #fff;\n  padding: 20px;\n  min-height: 70vh;\n}\n", ""]);

// exports
